export default __webpack_public_path__ + "img/ce1bded0857ad2feef4ff7dd8926e1bc.png";